import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import TossPaymentFailureView from 'src/views/TossPaymentFailure';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default TossPaymentFailureView;